import { bind } from '@react-rxjs/core';
import { request } from './request';
import { convertToAsyncTaskState } from '../utils/rxjs/task';
import { createSignal } from '@react-rxjs/utils';
import { interval, map, startWith, switchMap } from 'rxjs';

export const [refresh$, refreshPrivateMileage] = createSignal();

export const [usePrivateMileage] = bind(
  refresh$.pipe(
    startWith(null),
    switchMap(() =>
      interval(3600000).pipe(
        startWith(null),
        switchMap(() =>
          request<number>(`/gateway/lcv-driver-service/v20220125/trip-type/private-distance`).pipe(
            map((val) => (val / 1000).toFixed(2)), // convert from meters to km
            convertToAsyncTaskState()
          )
        )
      )
    )
  ),
  { running: false, result: null, error: null }
);
